import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = (category) =>
  api.get("/products", { params: category ? { category } : {} }).then((r) => r.data);

export const fetchCategories = () =>
  api.get("/products/categories").then((r) => r.data);

export const submitInquiry = (payload) =>
  api.post("/inquiries", payload).then((r) => r.data);
